import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import { IconButton, Skeleton } from 'uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { setHistoryPaneState } from 'state/predictions'
import { useGetIsFetchingHistory } from 'state/predictions/hooks'

const ImgIcon = styled.img`
  width: 20px;
  height: 20px;
`

const HistoryButton = () => {
  const isFetchingHistory = useGetIsFetchingHistory()
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()

  const handleClick = () => {
    dispatch(setHistoryPaneState(true))
  }

  return (
    <IconButton
      id="prediction-history-button"
      style={{ background: 'white', borderRadius: '40px', padding: '0', width: '40px', height: '40px' }}
      onClick={handleClick}
      isLoading={isFetchingHistory}
      disabled={!account}
    >
      {isFetchingHistory ? (
        <Skeleton width="20px" height="20px" />
      ) : (
        <ImgIcon src={require('assets/images/prediction/refresh.svg').default} />
      )}
    </IconButton>
  )
}

export default HistoryButton
